// src/utils/i18n.js

const translations = {
  fr: {
    nav_discover: "Découvrir",
    nav_history: "Histoire",
    nav_tourism: "Tourisme",
    nav_talents: "Talents",
    nav_football: "Football",
    nav_news: "Actualités",
    nav_mairie: "Mairie",
    nav_directory: "Annuaire",
    hero_eyebrow: "Cambérène · Côte Atlantique · Sénégal",
    hero_h1: "Entre spiritualité,<br />culture <span class=\"ital\">&amp; modernité.</span>",
    hero_lede: "Village layène posé sur la côte nord de Dakar, Cambérène raconte une mémoire ancienne et un présent vibrant — pirogues, terrains de sable, voix de la mer.",
    hero_btn_primary: "Découvrir le village",
    hero_btn_ghost: "Explorer la culture",
    hero_scroll: "Faire défiler",
    hero_counter1: "De Dakar centre",
    hero_counter2: "Fondation du village",
    hero_counter3: "Plage · Vent O 14 km/h",
    disc_eyebrow: "Sept portes vers le village",
    disc_h2: "Sept entrées,<br /><span class=\"ital\">une seule histoire.</span>",
    disc_lede: "Choisissez votre seuil. Chaque porte ouvre sur une facette du quotidien cambérénois — sacrée, sportive, marchande, marine.",
    disc_c1_title: "Le village fondateur",
    disc_c1_desc: "De Seydina Limamou Laye à aujourd'hui, le récit d'une communauté assise face à l'océan.",
    disc_c1_read: "Lecture · 6 min",
    disc_c2_title: "Culture Layène",
    disc_c2_desc: "Foi, blanc, tassou — comprendre le tariqa qui irrigue toute la vie sociale du village.",
    disc_c2_read: "Archive · 12 entrées",
    disc_c3_title: "Plages",
    disc_c3_count: "3 spots",
    disc_c4_title: "ASC &amp; Foot",
    disc_c4_count: "Saison '26",
    disc_c5_title: "Talents",
    disc_c5_count: "28 portraits",
    disc_c6_title: "Business local",
    disc_c6_desc: "Restaurants, ateliers, services — un annuaire vivant tenu par la communauté.",
    disc_c6_count: "142 commerces référencés",
    disc_c7_title: "Galerie",
    disc_c7_count: "+ 480 clichés",
    story_eyebrow: "Récit · Cambérène, depuis 1884",
    story_h2: "Une mémoire posée<br />face <span class=\"ital\">à l'océan.</span>",
    story_lede: "Le village naît à la fin du XIXᵉ siècle autour de la figure de Seydina Limamou Laye. Les pirogues, les ablutions à l'aube, les processions blanches et les chants tassou construisent un quotidien où le sacré et le quotidien s'enchâssent.",
    story_quote: "« Cambérène n'est pas un quartier de Dakar.<br />C'est un village qui regarde l'océan en face. »",
    story_quote_src: "— Recueilli auprès des anciens, 2024",
    story_t1_year: "1884",
    story_t1_title: "Fondation",
    story_t1_desc: "Seydina Limamou Laye se retire à Cambérène — naissance de la confrérie layène et du village.",
    story_t2_year: "1909 — 1949",
    story_t2_title: "Construction de la mosquée",
    story_t2_desc: "Édifiée pierre après pierre par les fidèles, elle devient le cœur architectural du village.",
    story_t3_year: "1965",
    story_t3_title: "Pêche artisanale",
    story_t3_desc: "L'organisation des pirogues structure l'économie. Le rivage de Cambérène devient un débarquadère majeur de la côte nord.",
    story_t4_year: "1986",
    story_t4_title: "Création de l'ASC",
    story_t4_desc: "Première équipe officielle du Navétane — Cambérène entre dans l'histoire du foot de quartier.",
    story_t5_year: "2024 →",
    story_t5_title: "Cambérène, plateforme",
    story_t5_desc: "La communauté ouvre ses archives et sa vie quotidienne au monde — c'est la plateforme que vous lisez.",
    tour_eyebrow: "Tourisme · Côte de Cambérène",
    tour_h2: "Sable, sel,<br /><span class=\"ital\">soleil tombant.</span>",
    tour_lede: "Cinq lieux à parcourir lentement — le débarquadère à l'aube, le sable à midi, le couchant depuis la digue.",
    tour_hero_label: "Featured · Plage Nord",
    tour_hero_title: "Le rivage qui regarde le soir.",
    tour_hero_s1: "Sable fin",
    tour_hero_s2: "247 avis",
    tour_hero_s3: "Heure dorée",
    tour_d1_title: "Pirogues à l'aube",
    tour_d1_meta: "05h30 · Pêche artisanale",
    tour_d2_title: "Marché aux poissons",
    tour_d2_meta: "Tous les jours · 06h–11h",
    tour_d3_title: "Thieboudiène du jour",
    tour_d3_meta: "Riz · poisson · côte",
    tour_d4_title: "La digue, le soir",
    tour_d4_meta: "Spot photo · 18h45",
    tour_map_label: "Plan interactif",
    tour_map_title: "5 lieux à explorer",
    tour_map_d1: "Featured",
    tour_map_d2: "Sacré",
    tour_map_d3: "Quotidien",
    talent_eyebrow: "Talents · Personnalités · 2026",
    talent_h2: "Visages<br /><span class=\"ital\">de Cambérène.</span>",
    talent_lede: "Artistes, sportifs, entrepreneurs, créateurs — celles et ceux qui portent le village au-delà de ses dunes.",
    talent_f_all: "Tous · 28",
    talent_f_art: "Artistes",
    talent_f_sport: "Sport",
    talent_f_ent: "Entrepreneurs",
    talent_f_cre: "Créateurs",
    talent_f_ain: "Aînés",
    talent_t1_role: "Musique",
    talent_t1_desc: "Voix tassou — mêle chants layènes traditionnels et production électronique.",
    talent_t1_from: "Cambérène · Plage",
    talent_t2_role: "Football",
    talent_t2_desc: "Capitaine de l'ASC — formé sur le sable, devenu attaquant en Ligue 1.",
    talent_t2_from: "Cambérène · ASC",
    talent_t3_role: "Mode",
    talent_t3_desc: "Fondatrice de la maison TASSOU — broderies cousues à la main, regard contemporain.",
    talent_t3_from: "Cambérène · Centre",
    talent_t4_role: "Pêcheur",
    talent_t4_desc: "Pêcheur depuis 32 ans — gardien d'un savoir maritime en voie de transmission.",
    talent_t4_from: "Cambérène · Quai",
    talent_see_all: "Voir les 28 portraits",
    asc_eyebrow: "ASC Cambérène · Saison 2026",
    asc_h2: "Le sable<br />qui forme <b>les jambes.</b>",
    asc_desc: "Le Navétane n'est pas qu'un tournoi de quartier — c'est l'école des pieds. Suivez l'ASC Cambérène, ses jeunes, ses matchs, ses soirs de stade.",
    asc_player_role: "Capitaine · Attaquant · #10",
    asc_player_desc: "Formé sur la plage de Cambérène. Recordman de buts du Navétane sur les trois dernières saisons.",
    asc_stat1: "Matchs",
    asc_stat2: "Buts",
    asc_stat3: "Passes D.",
    asc_match_label: "Navétane · 32ᵉ journée",
    asc_live: "EN DIRECT · 78'",
    asc_venue: "Stade Iba Mar Diop",
    asc_upcoming_title: "Prochaines rencontres",
    asc_m1_vs: "ASC Cambérène — ASC Pikine<small>20h00 · Domicile</small>",
    asc_m1_loc: "⌖ HOME",
    asc_m2_vs: "ASC Hann — ASC Cambérène<small>17h30 · Extérieur</small>",
    asc_m2_loc: "→ AWAY",
    asc_m3_vs: "Finale Régionale<small>21h00 · Stade Léopold Senghor</small>",
    asc_m3_loc: "★ FINAL",
    news_eyebrow: "Cambérène News · Édition du jour",
    news_h2: "Le journal<br />du <span class=\"ital\">village.</span>",
    news_lede: "Initiatives jeunesse, événements religieux, vie associative. Ce qui se vit à Cambérène, raconté depuis Cambérène.",
    news_cat1: "Jeunesse",
    news_a1_title: "Vingt jeunes de Cambérène lancent leur premier studio créatif.",
    news_a1_desc: "Photographie, vidéo, son — un collectif local équipé par la diaspora ouvre ses portes ce mois-ci, avec l'ambition de raconter le village avec ses propres outils.",
    news_a1_byline: "07 Mai 2026 · Aminata Diop · 4 min",
    news_cat2: "Spirituel",
    news_a2_title: "Préparatifs du grand Appel — calendrier &amp; rites.",
    news_a2_desc: "Le pèlerinage approche. Les détails de l'organisation, jour après jour.",
    news_a2_byline: "06 Mai · Cheikh L. · 3 min",
    news_cat3: "Environnement",
    news_a3_title: "Plage propre : 380 kg de déchets retirés en un samedi.",
    news_a3_desc: "L'opération mensuelle a battu son record de mobilisation.",
    news_a3_byline: "04 Mai · Yacine Ba · 2 min",
    news_see_all: "Toutes les actualités",
    mairie_eyebrow: "Municipalité de Cambérène · Mandat 2022 — 2027",
    mairie_h2: "Au service<br /><span class=\"ital\">du village.</span>",
    mairie_lede: "La Mairie de Cambérène œuvre chaque jour pour la voirie, l'éducation, la jeunesse, l'environnement et la préservation du patrimoine. Suivez les chantiers en cours et la vie démocratique du village.",
    mairie_mayor_eyebrow: "Mot du Maire",
    mairie_mayor_quote: "« Cambérène n'appartient ni au passé ni à demain — elle se construit, chaque matin, par les mains de ses habitants. La Mairie n'est que le prolongement de cette volonté commune. »",
    mairie_mayor_title: "Maire de Cambérène · Élu en 2022",
    mairie_mayor_read: "Lire le discours",
    mairie_proj_eyebrow: "Chantiers en cours · Mai 2026",
    mairie_p1_lab: "En cours · Voirie",
    mairie_p1_title: "Réhabilitation de la rue 8 et de la digue Nord",
    mairie_p1_delivery: "Livraison juillet",
    mairie_p2_lab: "En cours · Éducation",
    mairie_p2_title: "Extension de l'école Layène — 6 nouvelles salles",
    mairie_p2_delivery: "Rentrée 2026",
    mairie_p3_lab: "En cours · Environnement",
    mairie_p3_title: "Programme \"Plage propre\" &amp; éclairage solaire",
    mairie_p3_delivery: "Phase finale",
    mairie_p4_lab: "Planifié · Jeunesse &amp; Sport",
    mairie_p4_title: "Maison de la jeunesse · médiathèque numérique",
    mairie_p4_delivery: "Études en cours",
    mairie_council_tag: "Conseil municipal · Public",
    mairie_council_title: "Séance ordinaire — Budget participatif 2026",
    mairie_council_desc: "Salle des délibérations · 16h00 · Ordre du jour publié 8 jours avant la séance.",
    mairie_council_btn: "Assister",
    mairie_civic1: "Budget annuel municipal",
    mairie_civic2: "Chantiers livrés en 2025",
    mairie_civic3: "Commissions ouvertes aux habitants",
    mairie_civic4: "Taux de transparence budgétaire",
    mairie_btn1: "Démarches en ligne",
    mairie_btn2: "Délibérations &amp; PV",
    mairie_btn3: "Signaler un problème",
    mairie_btn4: "Contacter la Mairie",
    extras_photo_label: "Photo du jour · 09.05.2026",
    extras_photo_title: "« Pirogues qui rentrent. »",
    extras_photo_desc: "Plage Nord, 18h41. Cliché par Mor Sène, photographe résident.",
    extras_know_label: "Le saviez-vous ?",
    extras_know_text: "L'année où Cambérène est devenu un village à part entière, sous l'impulsion de Seydina Limamou Laye.",
    extras_know_src: "142 ans · Source : Archives de Cambérène",
    extras_weather_label: "Plage de Cambérène",
    extras_weather_desc: "Ensoleillé · idéal baignade",
    extras_weather_w1: "Vent O",
    extras_weather_w2: "Vagues",
    extras_weather_w3: "Coucher",
    gallery_eyebrow: "Galerie · 480+ clichés",
    gallery_h2: "Le village,<br /><span class=\"ital\">en images.</span>",
    gallery_lede: "Drone, vie de plage, cérémonies, foot, pêche. Une bibliothèque visuelle ouverte à la communauté.",
    dir_eyebrow: "Annuaire · 142 commerces référencés",
    dir_h2: "Le village<br /><span class=\"ital\">vous accueille.</span>",
    dir_lede: "Tenu et vérifié par la communauté. Restaurants, ateliers, boutiques, services — soutenez l'économie locale.",
    dir_f_all: "Tous · 142",
    dir_f_rest: "Restaurants",
    dir_f_shop: "Boutiques",
    dir_f_craft: "Artisans",
    dir_f_serv: "Services",
    dir_f_hotel: "Hébergement",
    dir_b1_cat: "Restaurant",
    dir_b1_desc: "Thieboudiène, yassa, daxin — table familiale tenue depuis 1998.<br />📍 Rue 8, Cambérène Centre",
    dir_b1_a1: "Itinéraire",
    dir_b1_a2: "Réserver",
    dir_b2_cat: "Artisan",
    dir_b2_desc: "Broderies traditionnelles main, sur-mesure en 7 jours.<br />📍 Rue 14, près de la mosquée",
    dir_b2_a1: "Itinéraire",
    dir_b2_a2: "Visiter",
    dir_b3_cat: "Service",
    dir_b3_desc: "Sorties pêche &amp; balades en mer, départ 06h00.<br />📍 Débarquadère Nord",
    dir_b3_a1: "Itinéraire",
    dir_b3_a2: "Booker",
    dir_see_all: "Parcourir l'annuaire complet",
    counter_eyebrow: "La communauté en chiffres",
    counter_h2: "Cambérène, vivante.",
    counter_updated: "↻ Mis à jour il y a 2 minutes",
    counter_c1: "Habitants",
    counter_c2: "Commerces",
    counter_c3: "Photos partagées",
    counter_c4: "Talents portés",
    mobile_eyebrow: "Version mobile · iOS / Android",
    mobile_h2: "Toujours dans<br /><span class=\"ital\">votre poche.</span>",
    mobile_lede: "L'expérience Cambérène pensée verticalement — feeds, profils, alertes événements et matchs en direct.",
    mobile_screen1_explore: "À explorer",
    mobile_screen1_discover: "Découvrir →",
    mobile_screen2_search: "Rechercher un lieu, un talent…",
    mobile_screen2_today: "Aujourd'hui · 9 mai",
    mobile_screen2_journal: "Le journal du village.",
    mobile_cat1: "Jeunesse",
    mobile_art1: "Vingt jeunes lancent leur studio créatif.",
    mobile_cat2: "Plage",
    mobile_art2: "380 kg de déchets retirés en un samedi.",
    mobile_tab1: "● Accueil",
    mobile_tab2: "Carte",
    mobile_tab3: "News",
    mobile_tab4: "Profil",
    mobile_cap1: "01 · Accueil",
    mobile_cap2: "02 · Feed",
    mobile_cap3: "03 · Talent",
    mobile_profile_role: "Voix Tassou · Musique",
    mobile_profile_desc: "Mêle chants layènes traditionnels et productions électroniques contemporaines.",
    mobile_follow: "Suivre +",
    mobile_listen: "Écouter",
    mobile_share: "Partager",
    nl_eyebrow: "Lettre du village · Mensuelle",
    nl_h2: "Recevez Cambérène<br /><span class=\"ital\">dans votre boîte.</span>",
    nl_lede: "Chaque premier dimanche : un récit, une photo du jour, les matchs de l'ASC, les nouveaux portraits, et l'agenda culturel du mois.",
    nl_email_placeholder: "votre@adresse.email",
    nl_btn: "S'abonner",
    nl_fine: "3 200 abonnés · sans spam · désabonnement en un clic",
    foot_brand_tagline: "Le village,<br />en ligne.",
    foot_brand_desc: "Plateforme communautaire portée par les habitants de Cambérène — récits, archives, vie locale, économie, sport.",
    foot_explore_title: "Explorer",
    foot_l1: "Découvrir",
    foot_l2: "Histoire",
    foot_l3: "Tourisme",
    foot_l4: "Talents",
    foot_l5: "ASC &amp; Foot",
    foot_l6: "Galerie",
    foot_community_title: "Communauté",
    foot_c1: "Devenir contributeur",
    foot_c2: "Soumettre une photo",
    foot_c3: "Référencer un commerce",
    foot_c4: "Diaspora",
    foot_c5: "Partenaires",
    foot_c6: "Presse &amp; média",
    foot_contact_title: "Contact",
    foot_ct1: "Cambérène, Dakar 14.78°N",
    foot_ct3: "Carte du village",
    foot_ct4: "Mentions légales",
    foot_ct5: "Charte communautaire",
    foot_copy: "© 2026 Cambérène — Tous droits réservés",
    foot_made: "Made with care · à Cambérène, par Cambérène",
    live_tag: "EN DIRECT",
    live_score: "<b>ASC Cambérène 2 — 1 ASC Yoff</b> · 78ᵉ minute",
    live_venue: "Stade Iba Mar Diop",
  },
  en: {
    nav_discover: "Discover",
    nav_history: "History",
    nav_tourism: "Tourism",
    nav_talents: "Talents",
    nav_football: "Football",
    nav_news: "News",
    nav_mairie: "Town Hall",
    nav_directory: "Directory",
    hero_eyebrow: "Cambérène · Atlantic Coast · Senegal",
    hero_h1: "Between spirituality,<br />culture <span class=\"ital\">&amp; modernity.</span>",
    hero_lede: "A Layène village on Dakar's northern coast, Cambérène tells an ancient memory and a vibrant present — fishing boats, sandy grounds, voices of the sea.",
    hero_btn_primary: "Discover the village",
    hero_btn_ghost: "Explore the culture",
    hero_scroll: "Scroll",
    hero_counter1: "From downtown Dakar",
    hero_counter2: "Village founded",
    hero_counter3: "Beach · W wind 14 km/h",
    disc_eyebrow: "Seven gates to the village",
    disc_h2: "Seven entries,<br /><span class=\"ital\">one story.</span>",
    disc_lede: "Choose your threshold. Each door opens onto a facet of daily Cambérène life — sacred, sporting, commercial, maritime.",
    disc_c1_title: "The founding village",
    disc_c1_desc: "From Seydina Limamou Laye to today, the story of a community seated before the ocean.",
    disc_c1_read: "Read · 6 min",
    disc_c2_title: "Layène Culture",
    disc_c2_desc: "Faith, white, tassou — understanding the tariqa that flows through all social life in the village.",
    disc_c2_read: "Archive · 12 entries",
    disc_c3_title: "Beaches",
    disc_c3_count: "3 spots",
    disc_c4_title: "ASC &amp; Football",
    disc_c4_count: "Season '26",
    disc_c5_title: "Talents",
    disc_c5_count: "28 portraits",
    disc_c6_title: "Local business",
    disc_c6_desc: "Restaurants, workshops, services — a living directory maintained by the community.",
    disc_c6_count: "142 listed businesses",
    disc_c7_title: "Gallery",
    disc_c7_count: "+ 480 photos",
    story_eyebrow: "Story · Cambérène, since 1884",
    story_h2: "A memory set<br />before <span class=\"ital\">the ocean.</span>",
    story_lede: "The village was born at the end of the 19th century around the figure of Seydina Limamou Laye. The fishing boats, dawn ablutions, white processions, and tassou chants build a daily life where the sacred and the everyday intertwine.",
    story_quote: "« Cambérène is not a neighbourhood of Dakar.<br />It is a village that faces the ocean head-on. »",
    story_quote_src: "— Collected from elders, 2024",
    story_t1_year: "1884",
    story_t1_title: "Founding",
    story_t1_desc: "Seydina Limamou Laye withdraws to Cambérène — birth of the Layène brotherhood and the village.",
    story_t2_year: "1909 — 1949",
    story_t2_title: "Mosque construction",
    story_t2_desc: "Built stone by stone by the faithful, it becomes the architectural heart of the village.",
    story_t3_year: "1965",
    story_t3_title: "Artisanal fishing",
    story_t3_desc: "The organisation of fishing boats structures the economy. Cambérène's shore becomes a major landing point on the northern coast.",
    story_t4_year: "1986",
    story_t4_title: "ASC founded",
    story_t4_desc: "First official Navétane team — Cambérène enters the history of neighbourhood football.",
    story_t5_year: "2024 →",
    story_t5_title: "Cambérène, platform",
    story_t5_desc: "The community opens its archives and daily life to the world — this is the platform you are reading.",
    tour_eyebrow: "Tourism · Cambérène Coast",
    tour_h2: "Sand, salt,<br /><span class=\"ital\">falling sun.</span>",
    tour_lede: "Five places to explore slowly — the landing at dawn, the sand at noon, the sunset from the seawall.",
    tour_hero_label: "Featured · North Beach",
    tour_hero_title: "The shore that watches the evening.",
    tour_hero_s1: "Fine sand",
    tour_hero_s2: "247 reviews",
    tour_hero_s3: "Golden hour",
    tour_d1_title: "Boats at dawn",
    tour_d1_meta: "05:30 · Artisanal fishing",
    tour_d2_title: "Fish market",
    tour_d2_meta: "Every day · 06:00–11:00",
    tour_d3_title: "Today's thieboudiène",
    tour_d3_meta: "Rice · fish · coast",
    tour_d4_title: "The seawall, at dusk",
    tour_d4_meta: "Photo spot · 18:45",
    tour_map_label: "Interactive map",
    tour_map_title: "5 places to explore",
    tour_map_d1: "Featured",
    tour_map_d2: "Sacred",
    tour_map_d3: "Everyday",
    talent_eyebrow: "Talents · Personalities · 2026",
    talent_h2: "Faces<br /><span class=\"ital\">of Cambérène.</span>",
    talent_lede: "Artists, athletes, entrepreneurs, creators — those who carry the village beyond its dunes.",
    talent_f_all: "All · 28",
    talent_f_art: "Artists",
    talent_f_sport: "Sport",
    talent_f_ent: "Entrepreneurs",
    talent_f_cre: "Creators",
    talent_f_ain: "Elders",
    talent_t1_role: "Music",
    talent_t1_desc: "Tassou voice — blending traditional Layène chants and electronic production.",
    talent_t1_from: "Cambérène · Beach",
    talent_t2_role: "Football",
    talent_t2_desc: "ASC captain — trained on sand, became a Ligue 1 striker.",
    talent_t2_from: "Cambérène · ASC",
    talent_t3_role: "Fashion",
    talent_t3_desc: "Founder of TASSOU house — hand-sewn embroideries, contemporary vision.",
    talent_t3_from: "Cambérène · Centre",
    talent_t4_role: "Fisherman",
    talent_t4_desc: "Fisherman for 32 years — guardian of a maritime knowledge being passed on.",
    talent_t4_from: "Cambérène · Wharf",
    talent_see_all: "See all 28 portraits",
    asc_eyebrow: "ASC Cambérène · Season 2026",
    asc_h2: "The sand<br />that builds <b>the legs.</b>",
    asc_desc: "The Navétane is not just a neighbourhood tournament — it is the school of feet. Follow ASC Cambérène, its youth, its matches, its stadium evenings.",
    asc_player_role: "Captain · Striker · #10",
    asc_player_desc: "Trained on Cambérène beach. Navétane top scorer over the last three seasons.",
    asc_stat1: "Matches",
    asc_stat2: "Goals",
    asc_stat3: "Assists",
    asc_match_label: "Navétane · Matchday 32",
    asc_live: "LIVE · 78'",
    asc_venue: "Iba Mar Diop Stadium",
    asc_upcoming_title: "Upcoming fixtures",
    asc_m1_vs: "ASC Cambérène — ASC Pikine<small>20:00 · Home</small>",
    asc_m1_loc: "⌖ HOME",
    asc_m2_vs: "ASC Hann — ASC Cambérène<small>17:30 · Away</small>",
    asc_m2_loc: "→ AWAY",
    asc_m3_vs: "Regional Final<small>21:00 · Léopold Senghor Stadium</small>",
    asc_m3_loc: "★ FINAL",
    news_eyebrow: "Cambérène News · Today's edition",
    news_h2: "The village<br /><span class=\"ital\">journal.</span>",
    news_lede: "Youth initiatives, religious events, community life. What happens in Cambérène, told from Cambérène.",
    news_cat1: "Youth",
    news_a1_title: "Twenty young people from Cambérène launch their first creative studio.",
    news_a1_desc: "Photography, video, sound — a local collective equipped by the diaspora opens this month, with the ambition to tell the village's story with its own tools.",
    news_a1_byline: "07 May 2026 · Aminata Diop · 4 min",
    news_cat2: "Spiritual",
    news_a2_title: "Preparations for the Grand Call — calendar &amp; rites.",
    news_a2_desc: "The pilgrimage approaches. The organisational details, day by day.",
    news_a2_byline: "06 May · Cheikh L. · 3 min",
    news_cat3: "Environment",
    news_a3_title: "Clean beach: 380 kg of waste removed in one Saturday.",
    news_a3_desc: "The monthly operation broke its mobilisation record.",
    news_a3_byline: "04 May · Yacine Ba · 2 min",
    news_see_all: "All news",
    mairie_eyebrow: "Municipality of Cambérène · Mandate 2022 — 2027",
    mairie_h2: "In service<br /><span class=\"ital\">of the village.</span>",
    mairie_lede: "The Cambérène Town Hall works every day for roads, education, youth, the environment and heritage preservation. Follow ongoing projects and the democratic life of the village.",
    mairie_mayor_eyebrow: "Mayor's word",
    mairie_mayor_quote: "« Cambérène belongs neither to the past nor to tomorrow — it is built, every morning, by the hands of its inhabitants. The Town Hall is merely the extension of this common will. »",
    mairie_mayor_title: "Mayor of Cambérène · Elected in 2022",
    mairie_mayor_read: "Read the speech",
    mairie_proj_eyebrow: "Ongoing projects · May 2026",
    mairie_p1_lab: "In progress · Roads",
    mairie_p1_title: "Rehabilitation of rue 8 and the North seawall",
    mairie_p1_delivery: "Delivery July",
    mairie_p2_lab: "In progress · Education",
    mairie_p2_title: "Extension of Layène school — 6 new classrooms",
    mairie_p2_delivery: "Back to school 2026",
    mairie_p3_lab: "In progress · Environment",
    mairie_p3_title: "\"Clean beach\" programme &amp; solar lighting",
    mairie_p3_delivery: "Final phase",
    mairie_p4_lab: "Planned · Youth &amp; Sport",
    mairie_p4_title: "Youth centre · digital media library",
    mairie_p4_delivery: "Studies underway",
    mairie_council_tag: "Municipal Council · Public",
    mairie_council_title: "Ordinary session — Participatory budget 2026",
    mairie_council_desc: "Deliberation room · 16:00 · Agenda published 8 days before the session.",
    mairie_council_btn: "Attend",
    mairie_civic1: "Annual municipal budget",
    mairie_civic2: "Projects completed in 2025",
    mairie_civic3: "Committees open to residents",
    mairie_civic4: "Budget transparency rate",
    mairie_btn1: "Online services",
    mairie_btn2: "Deliberations &amp; minutes",
    mairie_btn3: "Report an issue",
    mairie_btn4: "Contact Town Hall",
    extras_photo_label: "Photo of the day · 09.05.2026",
    extras_photo_title: "« Boats coming home. »",
    extras_photo_desc: "North Beach, 18:41. Shot by Mor Sène, resident photographer.",
    extras_know_label: "Did you know?",
    extras_know_text: "The year Cambérène became a village in its own right, under the impetus of Seydina Limamou Laye.",
    extras_know_src: "142 years · Source: Cambérène Archives",
    extras_weather_label: "Cambérène Beach",
    extras_weather_desc: "Sunny · ideal for swimming",
    extras_weather_w1: "W Wind",
    extras_weather_w2: "Waves",
    extras_weather_w3: "Sunset",
    gallery_eyebrow: "Gallery · 480+ photos",
    gallery_h2: "The village,<br /><span class=\"ital\">in pictures.</span>",
    gallery_lede: "Drone, beach life, ceremonies, football, fishing. A visual library open to the community.",
    dir_eyebrow: "Directory · 142 listed businesses",
    dir_h2: "The village<br /><span class=\"ital\">welcomes you.</span>",
    dir_lede: "Maintained and verified by the community. Restaurants, workshops, boutiques, services — support the local economy.",
    dir_f_all: "All · 142",
    dir_f_rest: "Restaurants",
    dir_f_shop: "Shops",
    dir_f_craft: "Craftspeople",
    dir_f_serv: "Services",
    dir_f_hotel: "Accommodation",
    dir_b1_cat: "Restaurant",
    dir_b1_desc: "Thieboudiène, yassa, daxin — family table established since 1998.<br />📍 Rue 8, Cambérène Centre",
    dir_b1_a1: "Directions",
    dir_b1_a2: "Book",
    dir_b2_cat: "Craftsperson",
    dir_b2_desc: "Traditional hand embroidery, custom-made in 7 days.<br />📍 Rue 14, near the mosque",
    dir_b2_a1: "Directions",
    dir_b2_a2: "Visit",
    dir_b3_cat: "Service",
    dir_b3_desc: "Fishing trips &amp; sea outings, departure 06:00.<br />📍 North landing",
    dir_b3_a1: "Directions",
    dir_b3_a2: "Book",
    dir_see_all: "Browse the full directory",
    counter_eyebrow: "The community in numbers",
    counter_h2: "Cambérène, alive.",
    counter_updated: "↻ Updated 2 minutes ago",
    counter_c1: "Inhabitants",
    counter_c2: "Businesses",
    counter_c3: "Shared photos",
    counter_c4: "Talents showcased",
    mobile_eyebrow: "Mobile version · iOS / Android",
    mobile_h2: "Always in<br /><span class=\"ital\">your pocket.</span>",
    mobile_lede: "The Cambérène experience designed vertically — feeds, profiles, event alerts and live matches.",
    mobile_screen1_explore: "Explore",
    mobile_screen1_discover: "Discover →",
    mobile_screen2_search: "Search a place, a talent…",
    mobile_screen2_today: "Today · 9 May",
    mobile_screen2_journal: "The village journal.",
    mobile_cat1: "Youth",
    mobile_art1: "Twenty young people launch their creative studio.",
    mobile_cat2: "Beach",
    mobile_art2: "380 kg of waste removed in one Saturday.",
    mobile_tab1: "● Home",
    mobile_tab2: "Map",
    mobile_tab3: "News",
    mobile_tab4: "Profile",
    mobile_cap1: "01 · Home",
    mobile_cap2: "02 · Feed",
    mobile_cap3: "03 · Talent",
    mobile_profile_role: "Tassou Voice · Music",
    mobile_profile_desc: "Blends traditional Layène chants with contemporary electronic productions.",
    mobile_follow: "Follow +",
    mobile_listen: "Listen",
    mobile_share: "Share",
    nl_eyebrow: "Village letter · Monthly",
    nl_h2: "Receive Cambérène<br /><span class=\"ital\">in your inbox.</span>",
    nl_lede: "Every first Sunday: a story, a photo of the day, ASC matches, new portraits, and the cultural agenda of the month.",
    nl_email_placeholder: "your@email.address",
    nl_btn: "Subscribe",
    nl_fine: "3,200 subscribers · no spam · unsubscribe in one click",
    foot_brand_tagline: "The village,<br />online.",
    foot_brand_desc: "Community platform carried by the inhabitants of Cambérène — stories, archives, local life, economy, sport.",
    foot_explore_title: "Explore",
    foot_l1: "Discover",
    foot_l2: "History",
    foot_l3: "Tourism",
    foot_l4: "Talents",
    foot_l5: "ASC &amp; Football",
    foot_l6: "Gallery",
    foot_community_title: "Community",
    foot_c1: "Become a contributor",
    foot_c2: "Submit a photo",
    foot_c3: "List a business",
    foot_c4: "Diaspora",
    foot_c5: "Partners",
    foot_c6: "Press &amp; media",
    foot_contact_title: "Contact",
    foot_ct1: "Cambérène, Dakar 14.78°N",
    foot_ct3: "Village map",
    foot_ct4: "Legal notice",
    foot_ct5: "Community charter",
    foot_copy: "© 2026 Cambérène — All rights reserved",
    foot_made: "Made with care · in Cambérène, by Cambérène",
    live_tag: "LIVE",
    live_score: "<b>ASC Cambérène 2 — 1 ASC Yoff</b> · 78th minute",
    live_venue: "Iba Mar Diop Stadium",
  }
};

let currentLang = localStorage.getItem('camb-lang') || 'fr';

export function applyLang(lang) {
  document.documentElement.lang = lang;
  const dict = translations[lang];
  document.querySelectorAll('[data-i18n]').forEach(el => {
    const k = el.dataset.i18n;
    if (dict[k] !== undefined) el.innerHTML = dict[k];
  });
  document.querySelectorAll('[data-i18n-ph]').forEach(el => {
    const k = el.dataset.i18nPh;
    if (dict[k] !== undefined) el.placeholder = dict[k];
  });
  document.querySelectorAll('.lang-toggle').forEach(btn => {
    btn.textContent = lang === 'fr' ? 'EN' : 'FR';
  });
  currentLang = lang;
  localStorage.setItem('camb-lang', lang);
}

export function toggleLang() {
  applyLang(currentLang === 'fr' ? 'en' : 'fr');
}

export function getCurrentLang() { return currentLang; }
